// GraficoPizza.tsx
import React, { useState } from "react";
import { Pie } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    ChartData,
    PluginOptionsByType,
} from "chart.js";
import { _DeepPartialObject } from "chart.js/types/utils";
import { BsCaretUpFill, BsCaretDownFill } from "react-icons/bs";
import { MensagemGraficoVazio } from "../MensagemGraficoVazio";
import AnimateHeight from "react-animate-height";

import "./styles.css";

ChartJS.register(ArcElement, Tooltip, Legend);

interface GraficoPizzaProps {
    tituloGrafico: string;
    subTituloGrafico?: string;
    labels: string[];
    porcentagens: number[];
    colorArray: string[];
    plugins?: _DeepPartialObject<PluginOptionsByType<"pie">>;
    mobile?: boolean;
    exibirCabecalho?: boolean;
}

export const GraficoPizza: React.FC<GraficoPizzaProps> = ({
    tituloGrafico,
    subTituloGrafico,
    labels,
    porcentagens,
    colorArray,
    plugins,
    mobile = false,
    exibirCabecalho = true,
}) => {
    const [dashboardAberta, setDashboardAberta] = useState(true);

    const data: ChartData<"pie", number[], string> = {
        labels,
        datasets: [
            {
                data: porcentagens,
                backgroundColor: colorArray,
                borderColor: "#fff",
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className="grafico-pizza-container">
            {exibirCabecalho && (
                <div
                    className="grafico-pizza-header"
                    onClick={() => setDashboardAberta(!dashboardAberta)}
                >
                    <h3>{tituloGrafico}</h3>
                    <span>
                        {dashboardAberta ? (
                            <BsCaretUpFill className="icon-toggle" />
                        ) : (
                            <BsCaretDownFill className="icon-toggle" />
                        )}
                    </span>
                </div>
            )}

            {subTituloGrafico && <h6 className="grafico-pizza-subtitulo">{subTituloGrafico}</h6>}

            <AnimateHeight duration={400} height={dashboardAberta ? "auto" : 0}>
                {porcentagens.length ? (
                    <div className={`grafico-pizza-chart-wrapper ${mobile ? "mobile" : ""}`}>
                        <Pie
                            data={data}
                            options={{
                                maintainAspectRatio: false,
                                plugins: plugins ? plugins : undefined,
                            }}
                        />
                    </div>
                ) : (
                    <MensagemGraficoVazio />
                )}
            </AnimateHeight>
        </div>
    );
};
